import { IOption } from "../../classes/package-listing"
import * as React from 'react';
import * as numeral from 'numeral';

import CartItems from '../../components/cart/cart-items';

import QuantitySelect from '../../components/cart/quantity-select';
import { CartContainerState, CartContainerViewProps } from '../../components/cart/container';
import { IPerformanceGroup, IPerformance, IPackage } from "../../custom/classes/production";
import LoaderView from '../../components/loader';
import OrderNotes from "../../components/cart/order-notes";
import SeatingPreferences from "../../components/cart/seating-preference";
import CartMessages from "../../components/cart/cart-messages";
import SeatingChoice from "../../components/cart/seat-choice";


class CartContainerView extends React.Component<CartContainerViewProps & CartContainerState> {

    lastCartCount: number = 0;
    lastPrice: number = 0;
    lastSelectedPricing: boolean = false;

    componentDidUpdate() {
        window.requestAnimationFrame(() => {
            const cartItemsQuantity = this.props.cartItems ? this.props.cartItems.size : 0;
            const price = this.props.packageSubTotal;
            if (this.lastCartCount != cartItemsQuantity || this.lastPrice != price || this.lastSelectedPricing != this.props.selectedPricing) {
                this.props.updateStickyCart();
                this.lastCartCount = cartItemsQuantity;
                this.lastPrice = price;
                this.lastSelectedPricing = this.props.selectedPricing;
            }
        });
    }

    render() {
        const packageMinNotReached = this.props.cartItems.size < this.props.packageMin;
        let allPerfGroupMinReached = checkForPerformanceGroupMin(this.props.performanceGroups, this.props.cartPerformancesInPerfGroup);
        // TODO? Some way to edit the "...selected" messaging here in the CMS
        const progressText = `<span class="h4-style">${this.props.cartItems.size}${this.props.packageMin ? `/${this.props.packageMin} selected</span>` : ''}${this.props.packageMax ? ` <span class="light-weight h4-style">(${this.props.packageMax} max)</span>` : ''}`;
        const headerText = `${this.props.text.miniCartTitle}`;

        return (
            <>
                <a href="#review" className="btn btn-icon-left stack-xs ace-subs-cart-link" data-show-button={this.props.showCartLink} onClick={() => this.props.toggleMiniCart(true)}>
                    {
                        this.props.packageMin || this.props.packageMax ?
                            <p className="ace-subs-cart-link-progress" dangerouslySetInnerHTML={{ __html: progressText }} />
                            : null
                    }
                    <p>
                        <svg className="svg-icon icon-arrow-down" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-arrow-down" />' }}></svg>
                        {/*TODO: Umbracofy this text*/}
                        Review Package
                    </p>
                </a>
                <div className="stack stack-border">
                    <div>
                        <h2 className="visually-hidden" id="review" tabIndex={-1}>{headerText}</h2>
                        <button type="button" className="btn btn-icon-left ace-subs-cart-trigger" onClick={() => this.props.toggleMiniCart(!this.props.miniCartOpen)} aria-expanded={this.props.miniCartOpen}>
                            <svg className="svg-icon icon-arrow-down" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-arrow-down" />' }}></svg>
                            {/*TODO: Umbracofy this text*/}
                            {
                                this.props.miniCartOpen ? <span>Hide </span> : <span>Show </span>
                            }
                            <span dangerouslySetInnerHTML={{ __html: headerText }} />
                        </button>
                        <div className="ace-hide-for-tablet stack-sm">
                            <p className="h2-style" aria-hidden="true" dangerouslySetInnerHTML={{ __html: headerText }} />
                        </div>
                        <div className="stack-sm space-top">
                            <CartMessages performanceGroupId={null} />
                        </div>
                    </div>
                    <div className="stack stack-border ace-subs-cart" data-minicart-open={this.props.miniCartOpen}>
                        <CartItems
                            packageMax={this.props.packageMax}
                            packageMin={this.props.packageMin}
                            performanceGroups={this.props.performanceGroups}></CartItems>
                        {
                            this.props.isRenewal ?
                                <SeatingChoice />
                                :
                                null
                        }
                        {                          
                            this.props.isUnseatedReservation ?
                                <>
                                    <SeatingPreferences />
                                    <QuantitySelect />
                                    <OrderNotes />                                       
                                </>
                                :
                                <QuantitySelect />
                        }
                        <LoaderView />
                    </div>
                </div>
                <div className="ace-subs-sidebar-footer space-top border-top" data-sticky-container>
                    <div className="stack ace-subs-sidebar-footer-inner" data-sticky-el data-margin-top="20" data-sticky-for="1024" data-sticky-class="stuck">
                        {
                            this.props.packageMin || this.props.packageMax ?
                                <p className="flex-between" dangerouslySetInnerHTML={{ __html: progressText }} />
                                : null
                        }
                        {
                            !packageMinNotReached && !this.props.selectedPricing && this.props.cartItems.size > 0 &&
                            <p className="error-message">
                                {/*TODO: Umbracofy these error messages, and I'm not sure if the logic is correct*/}
                                {this.props.isUnseatedReservation ?
                                    <a href="#review" onClick={() => this.props.toggleMiniCart(true)}>Select seating zone(s) to continue.</a>
                                    :
                                    <a href="#review" onClick={() => this.props.toggleMiniCart(true)}>Select ticket quantity to continue.</a>
                                }
                            </p>
                        }
                        {
                            this.props.isUnseatedReservation ?
                                <p className="flex-between">
                                    <span className="bold">{`${this.props.text.packageSubtotalTitle}:`}</span>
                                    <span className="">{`${numeral(this.props.packageSubTotal).format('$0,0.00')}`}</span>
                                </p>
                                : null
                        }
                        <button className="btn-primary btn-full-width" disabled={!this.props.selectedPricing || packageMinNotReached || !allPerfGroupMinReached}
                            onClick={() => {
                                this.props.processPackageClick();
                            }}>
                            {
                                this.props.isUnseatedReservation ? this.props.text.reservePackageButtonText
                                    : this.props.text.continueToSeatingButtonText
                            }
                        </button>
                    </div>
                </div>
            </>
        );

    }
}

export default CartContainerView;

function checkForPerformanceGroupMin(performanceGroups: Array<IPerformanceGroup>, cartPerformancesInPerfGroup: Map<number, Array<number>>) {
    let allPerfGroupMinReached = true;
    performanceGroups.filter(pg => pg.minimumPerformances > 0).forEach(pg => {
        const perfGroupMinNotReached = pg.minimumPerformances - cartPerformancesInPerfGroup.get(pg.id).length > 0;
        if (perfGroupMinNotReached) {
            allPerfGroupMinReached = false;
        }
    });
    return allPerfGroupMinReached;
}
